module.exports = __webpack_public_path__ + "img/c0.feb885eb.jpg";